import { KeyDownCalendarEventPayload } from '../../schema';
import shouldUseMonarchShortcuts from 'owa-hotkeys/lib/utils/shouldUseMonarchShortcuts';

export function isKeyboardCalendarEventInteractionReply(payload: KeyDownCalendarEventPayload) {
    const usingMonarchShortcuts = shouldUseMonarchShortcuts();
    const event = payload?.event;

    return (
        event &&
        ((usingMonarchShortcuts && event.ctrlKey && event.key == 'r') ||
            (!usingMonarchShortcuts && event.altKey && event.key == 'r'))
    );
}
